module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Medium-b7650fac4e6149afb0f20c9f9c97d72d.otf";